import { render, staticRenderFns } from "./sfc-cap-rating.vue?vue&type=template&id=c9203220&scoped=true&lang=pug&"
import script from "./sfc-cap-rating.vue?vue&type=script&lang=js&"
export * from "./sfc-cap-rating.vue?vue&type=script&lang=js&"
import style0 from "./sfc-cap-rating.vue?vue&type=style&index=0&id=c9203220&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9203220",
  null
  
)

export default component.exports